import wasm from "../engine/Cargo.toml";

export const crate = await wasm({
    serverPath: "/build/assets/",
});
